var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{key:_vm.key,staticClass:"download-templateCustom-custom button-cancel",attrs:{"disabled":_vm.disabled},on:{"click":_vm.downloadTemplate}},[_c('i',{staticClass:"icon-gongyong_xiazai"}),_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }